export default __webpack_public_path__ + "static/media/4CONNECTIONISSUES.50eb264f.mp3";